import React from 'react';
import { ButtonContentfulModel } from 'src/api/models/Button';
import LinkBranded from 'src/elements/links/Link.branded';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { BannerContainer, BannerContent, EngagementCard, EngagementCardContent } from './engagementDrop.areYouReady.styles';

interface AreYouReadyBannerProps {
  title: string;
  description: string;
  actionButton: ButtonContentfulModel;
}

const AreYouReadyBanner = ({ title, description, actionButton }: AreYouReadyBannerProps):JSX.Element => {
  return (
    <BannerContainer>
      <BannerContent>
        <Heading
          text={title}
          size="11.6rem"
          sizeSubLg="9.8rem"
          sizeSm="3.8rem"
          align="center"
          lineHeight="11.6rem"
          color="#FF00FF"
        />
        <EngagementCard>
          <EngagementCardContent>
            <Paragraph
              text={description}
              size="3.4rem"
              sizeSubLg="2rem"
              sizeSm="1.5rem"
              weight="light"
              align="left"
              color="#ffffff"
            />
            <LinkBranded
              text={actionButton.text}
              url={actionButton.url}
              backgroundColor="#FF00FF"
              justify="center"
            />
          </EngagementCardContent>
        </EngagementCard>
      </BannerContent>
    </BannerContainer>
  )
}

export default AreYouReadyBanner;
